export const languages = [
  { code: "en", language: "English" },
  { code: "fr", language: "French" },
  { code: "nl", language: "Dutch" },
];